/** Toont het aantal opeenvolgende dagen waarop minstens één taak is afgerond. */
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import { Box } from '@mui/material';
import { StatBlock } from '@/components/ui/StatBlock';
import { useTasksContext } from '@/features/tasks';
import { getStreakTwoIconPulseSx } from '@/features/today/components/completionStreakPulseSx';
import { useCompletionStreak } from '@/features/today/hooks/use-completion-streak';
import { useStreakTwoPulse } from '@/features/today/hooks/use-streak-two-pulse';
import { useT } from '@/i18n/useT';

const CompletionStreak = () => {
  const t = useT();
  const { allTasks } = useTasksContext();
  const streak = useCompletionStreak(allTasks);
  const { pulseActive, onPulseEnd } = useStreakTwoPulse(streak);

  if (streak <= 0) return null;

  return (
    <StatBlock
      value={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.75,
          }}
        >
          <Box
            component="span"
            data-testid={pulseActive ? 'streak-two-pulse' : undefined}
            onAnimationEnd={pulseActive ? onPulseEnd : undefined}
            sx={{
              display: 'inline-flex',
              ...(pulseActive ? getStreakTwoIconPulseSx() : {}),
            }}
          >
            <LocalFireDepartmentIcon
              aria-hidden="true"
              sx={{ fontSize: 26, color: 'success.main' }}
            />
          </Box>
          {streak}
        </Box>
      }
      label={
        streak === 1
          ? t('completionstreak.day', 'dag op rij')
          : t('completionstreak.days', 'dagen op rij')
      }
    />
  );
};

export default CompletionStreak;
